import React, { PropTypes } from 'react';
import { newsConnect, announcementsConnect } from '../../connect';
import { CardContainer, CardFetchContainer, ResourcesContainer } from '../../components';

const News = newsConnect(({ newsFetch }) => (
  <CardFetchContainer
    fetch={newsFetch}
    title="In the News"
    iconUrl="https://cdn.auth0.com/website/assets/pages/press/img/icon-news-74f3d405f9.svg"
    alt="News icon"
    linkText="See all News"
    link="/press/news"
    isNews
  />
));

const Announcements = announcementsConnect(({ announcementsFetch }) => (
  <CardFetchContainer
    fetch={announcementsFetch}
    title="Announcements"
    iconUrl="https://cdn.auth0.com/website/assets/pages/press/img/icon-announ-425ce9b8db.svg"
    alt="Announcements icon"
    linkText="See all Announcements"
    link="/press/announcements"
  />
));

const Details = ({ announcements, news }) => (
  <div>
    <section className="section-announcements">
      {announcements
        ? <CardContainer
            title="Announcements"
            iconUrl="https://cdn.auth0.com/website/assets/pages/press/img/icon-announ-425ce9b8db.svg"
            alt="Announcements icon"
            linkText="See all Announcements"
            link="/press/announcements"
            items={announcements}
          />
        : <Announcements />}
    </section>
    <section className="section-news">
      {news
        ? <CardContainer
            title="In the News"
            iconUrl="https://cdn.auth0.com/website/assets/pages/press/img/icon-news-74f3d405f9.svg"
            alt="News icon"
            linkText="See all News"
            link="/press/news"
            items={news}
            isNews
          />
        : <News />}
    </section>
    <section className="section-media">
      <ResourcesContainer
        mainAssetsDownloadLink="https://cdn2.auth0.com/website/auth0-assets-logos.zip"
        secondaryAssetsDownloadLink="https://cdn2.auth0.com/website/auth0-assets-badge-products-logos.zip"
      />
    </section>
  </div>
);

const propsValidation = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  fullDate: PropTypes.string.isRequired
};

Details.propTypes = {
  announcements: PropTypes.arrayOf(PropTypes.shape(propsValidation)),
  news: PropTypes.arrayOf(PropTypes.shape(propsValidation))
};

export default Details;



// WEBPACK FOOTER //
// ./src/pages/press/containers/Details/Details.js